import React, { type ReactNode } from 'react';
import { useLocation, useMatch, useNavigate, useResolvedPath } from 'react-router-dom';

export interface RouterLinkProps {
	path: string;
	replaceLastPathOnly?: boolean;
	matchSearchParams?: boolean;
	children: (selected: boolean, navigateTo: () => void) => ReactNode;
}

export function RouterLink({ path, replaceLastPathOnly = true, matchSearchParams = false, children }: RouterLinkProps) {
	const resolvedPath = useResolvedPath(path);
	const matchResult = useMatch({ path: resolvedPath.pathname, end: replaceLastPathOnly });
	const location = useLocation();

	let selected = Boolean(matchResult);
	if (selected && matchSearchParams) {
		selected = resolvedPath.search === location.search;
	}

	const navigate = useNavigate();

	return <>{children(selected, () => navigate(path))}</>;
}
